/**
 * Overview:
 * This file provides typed Redux hooks for the application.
 * It simplifies access to the Redux store by exposing strongly
 * typed versions of useDispatch and useSelector, improving
 * type safety and developer experience across components.
 */

import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "./index";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
